export default "__VITE_ASSET__DmV9Xp$L__"